import { useState } from 'react'

export type FetchStatus = 'initial' | 'fetching' | 'resolved' | 'error'

export function useStatus<CustomStatus = FetchStatus>(
  initialStatus?: CustomStatus | FetchStatus
) {
  return useState<CustomStatus | FetchStatus>(initialStatus || 'initial')
}
